<template>
  <div class="card">
    <div class="card-content">
      <div v-if="shipment.container_number || shipment.container_type_str">
        <strong>Container</strong>
        <div class="content" v-if="shipment.container_number">{{ shipment.container_number }}</div>
      </div>
      <div v-if="shipment.container_type_str">
        <strong>Container Type Size</strong>
        <div class="content">{{ shipment.container_type_str }}</div>
      </div>
      <div v-if="shipment.booking_number">
        <strong>Booking</strong>
        <div class="content">{{ shipment.booking_number }}</div>
      </div>
      <div v-if="shipment.bl_number">
        <strong>BL</strong>
        <div class="content">{{ shipment.bl_number }}</div>
      </div>
      <div v-if="shipment.client_code">
        <strong>Client Code</strong>
        <div class="content">{{ shipment.client_code }}</div>
      </div>
      <div v-if="shipment.carrier_name">
        <strong>Carrier</strong>
        <div class="content">{{ shipment.carrier_name }}</div>
      </div>
      <div v-if="notEmptyObject(shipment.sf_data)">
        <strong>Custom Form</strong>
        <div class="content" v-for="(value, name, index) in shipment.sf_data" :key=index>
          <span>{{ name }}: {{ value }}</span>
        </div>
      </div>
      <div v-if="shipment.project">
        <strong>Project</strong>
        <div class="content">{{ shipment.project }}</div>
      </div>
      <div v-if="shipment.tracking_request">
        <router-link :to="{ name: 'tracking-request', params: { id: shipment.tracking_request } }">
          <i class="fa fa-link" />
          <strong>Go to Tracking Request</strong>
        </router-link>
      </div>
    </div>
    <div class="card-content">
      <article class="media">
        <figure class="media-left">
          <span class="fa fa-check-circle fa-fw has-text-success is-size-3"></span>
        </figure>
        <div class="media-content">
          <div class="content">
            <p class="has-text-success">{{ shipment.status_verbose }}</p>
            <small></small>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'shipment',
  props: ['shipment'],
  computed: {
  },
  methods: {
    notEmptyObject (someObject) {
      if (someObject) {
        var parsedobj = JSON.parse(JSON.stringify(someObject))
        return Object.keys(parsedobj).length
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/ShipmentCard.vue